/** Playing cards: a standard 52-card deck. */
import type { Rng } from "./rng.ts";

export type Suit = "C" | "D" | "H" | "S";
export const SUITS: readonly Suit[] = ["C", "D", "H", "S"];

/** Rank value: 2..10 face value, 11=J, 12=Q, 13=K, 14=A. */
export type Rank = 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
export const RANKS: readonly Rank[] = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];

export interface Card {
  rank: Rank;
  suit: Suit;
}

const RANK_LABEL: Record<number, string> = {
  11: "J",
  12: "Q",
  13: "K",
  14: "A",
};

export function rankLabel(rank: Rank): string {
  return RANK_LABEL[rank] ?? String(rank);
}

const SUIT_GLYPH: Record<Suit, string> = { C: "♣", D: "♦", H: "♥", S: "♠" };

export function cardToString(c: Card): string {
  return `${rankLabel(c.rank)}${SUIT_GLYPH[c.suit]}`;
}

export function handToString(cards: readonly Card[]): string {
  return cards.map(cardToString).join(" ");
}

/** Fresh, ordered 52-card deck. */
export function makeDeck(): Card[] {
  const deck: Card[] = [];
  for (const suit of SUITS) {
    for (const rank of RANKS) {
      deck.push({ rank, suit });
    }
  }
  return deck;
}

export function shuffledDeck(rng: Rng): Card[] {
  return rng.shuffle(makeDeck());
}
